import { CareerSiteFiltersOption } from 'api-clients/monolith';
import { IntlShape } from 'react-intl';

export const getSortOptions = (intl: IntlShape): CareerSiteFiltersOption[] => [
  {
    key: 'date_posted',
    label: intl.formatMessage({
      defaultMessage: 'Date Posted',
      description: 'Sort by date posted option',
    }),
  },
  {
    key: 'distance',
    label: intl.formatMessage({
      defaultMessage: 'Distance',
      description: 'Sort by distance option',
    }),
  },
  {
    key: 'title',
    label: intl.formatMessage({
      defaultMessage: 'Job Name',
      description: 'Sort by job name option',
    }),
  },
];
